// src/data/cases.js
// 사례글 페이지. 현재는 플레이스홀더(coming-soon). 추후 본문은 별도 업로드.

export const casesData = [
  {
    slug: 'case-dental-scams',
    title: '투명치과·이편한치과 먹튀 사건',
    summary: '대규모 치과 먹튀 사태의 법적 대응 실무를 담을 예정입니다.',
    status: 'coming-soon',
  },
  {
    slug: 'case-social-issues',
    title: '인보사·맘모톰 의료 이슈 수행 기록',
    summary: '사회적 파장이 컸던 의료 이슈에 대한 대응 전략과 결과를 공유할 예정입니다.',
    status: 'coming-soon',
  },
  {
    slug: 'case-certified-track',
    title: '대한변협 인증 전문 변호사 수행 사건',
    summary: '의료법·형사법 전문 인증 변호사로서의 대표 사건들을 정리할 예정입니다.',
    status: 'coming-soon',
  },
  {
    slug: 'case-association-work',
    title: '의료인 단체 고문 자문 프로젝트',
    summary: '대한치과의사협회 등 단체 자문의 대표 사례를 정리할 예정입니다.',
    status: 'coming-soon',
  },
  {
    slug: 'case-biotech-deals',
    title: '바이오벤처 투자·M&A 자문 사례',
    summary: '바이오·헬스케어 기업의 M&A·투자 자문 실적을 공유할 예정입니다.',
    status: 'coming-soon',
  },
];

export function getCaseBySlug(slug) {
  return casesData.find((c) => c.slug === slug);
}
